import Vue from "vue";

export default {
  fetchAccount() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/system-settings/account-settings")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  createAccount(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put("/organization/system-settings/account-settings", data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  imageUpload(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          "/organization/system-settings/account-settings/upload-image",
          data
        )
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getHoliday() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/system-settings/general-settings/public-holidays")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  createHoliday(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(
          "/organization/system-settings/general-settings/public-holidays",
          data
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  deleteHoliday(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(
          `organization/system-settings/general-settings/public-holidays/${id}`
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
};
